import TextField from '@mui/material/TextField';
import styled from 'styled-components';

export const StyledFormTextField = styled(TextField)<{ $gridColumnInput?: string }>`
  grid-column: ${({ $gridColumnInput }) => $gridColumnInput};

  .MuiInputBase-input {
    height: auto;
    color: var(--color-grayscale-black);

    ::placeholder {
      color: var(--color-gray-70);
      opacity: 1;
    }
  }

  .MuiInputAdornment-root {
    .MuiTypography-root {
      color: var(--color-gray-60);
    }

    .MuiSelect-icon {
      right: var(--sizes-30);
    }
  }

  & .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid var(--color-grayscale-black);
  }

  & .MuiInputAdornment-positionEnd .MuiTypography-root {
    font: var(--font-extra-small-12pt-bold);
  }

  & .Mui-focused .MuiInputAdornment-root {
    .MuiTypography-root {
      color: var(--color-grayscale-black);
    }
  }

  .Mui-disabled {
    :hover {
      cursor: not-allowed;
    }
  }
`;
